'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ConfigurationFlightTagController = function ConfigurationFlightTagController(dataRetrieverService, $scope, configurationFlightTagService, $q, $log, staticDataService, configurationService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'configuration-flight-tag-mode').setCustomSearchCriteriaRules([]);
  var CONFLICT_ERROR_CODE = 409;
  var TIME_FORMAT_REG_EXP = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
  var reloadFlightTag = staticDataService.loadFlightTags;
  $scope.selectedRows = [];
  $scope.showDeleteModal = false;
  function postColumnsErrorHandler(response) {
    if (response.status === CONFLICT_ERROR_CODE) {
      $log.error('ConfigurationFlightTagController: postColumnsErrorHandler - Duplicate record exists');
      toastr.error('Duplicated records exist.<br>Please correct data before saving.');
    } else {
      var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
      $log.error('ConfigurationFlightTagController: postColumnsErrorHandler - ' + errorMsg);
      toastr.error(errorMsg);
    }
    return $q.reject();
  }
  $scope.customErrorMessage = function () {
    return $scope.validationErrorMessage;
  };
  $scope.customRemove = function (rowsToBeRemoved) {
    $scope.selectedRows = rowsToBeRemoved;
    $scope.showDeleteModal = true;
    return false;
  };
  $scope.customSave = function (rows) {
    return configurationFlightTagService.save(rows)["catch"](postColumnsErrorHandler).then(reloadFlightTag).then(function () {
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.customAddNew = function (row) {
    row.carrierCode = configurationService.getHostAndSubsidiaryCarriers()[0];
    row.departureDateDaysOfWeek = 'Su,Mo,Tu,We,Th,Fr,Sa';
    return row;
  };
  $scope.customSaveValidation = function (rows, gridData) {
    $scope.validationErrorMessage = '';
    _.forEach(rows, function (row) {
      $scope.validationErrorMessage = validateRow(row);
      if (!_.isEmpty($scope.validationErrorMessage)) {
        return false;
      }
    });
    if (_.isEmpty($scope.validationErrorMessage)) {
      for (var i = 0; i < rows.length; ++i) {
        var row = rows[i];
        $scope.validationErrorMessage = duplicateDetection(row, gridData);
        if (!_.isEmpty($scope.validationErrorMessage)) {
          return false;
        }
      }
    }
    return _.isEmpty($scope.validationErrorMessage);
  };
  $scope.makeExportToCsv = function (data) {
    if (!data.length) {
      toastr.warning('Nothing to export');
      return;
    }
    configurationFlightTagService.exportToCsv(data);
  };
  function areRowsTheSame(rowToCompare, row) {
    return rowToCompare.flightTagName === row.flightTagName && rowToCompare.carrierCode === row.carrierCode && (rowToCompare.flightNumber && rowToCompare.flightNumber !== '' ? rowToCompare.flightNumber : undefined) === (row.flightNumber && row.flightNumber !== '' ? row.flightNumber.toString() : undefined) && (rowToCompare.legOrigin === row.legOrigin || row.legOrigin === '' && !rowToCompare.legOrigin) && (rowToCompare.legDestination === row.legDestination || row.legDestination === '' && !rowToCompare.legDestination) && rowToCompare.departureDateRangeStart.isSame(row.departureDateRangeStart) && (rowToCompare.departureDateRangeEnd && rowToCompare.departureDateRangeEnd.isSame(row.departureDateRangeEnd) || !rowToCompare.departureDateRangeEnd && !row.departureDateRangeEnd) && (rowToCompare.departureTimeRangeStart && rowToCompare.departureTimeRangeStart.isSame(row.departureTimeRangeStart) || !rowToCompare.departureTimeRangeStart && !row.departureTimeRangeStart) && (rowToCompare.departureTimeRangeEnd && rowToCompare.departureTimeRangeEnd.isSame(row.departureTimeRangeEnd) || !rowToCompare.departureTimeRangeEnd && !row.departureTimeRangeEnd) && (rowToCompare.departureDateDaysOfWeek ? rowToCompare.departureDateDaysOfWeek.toString() : rowToCompare.departureDateDaysOfWeek) === (row.departureDateDaysOfWeek ? row.departureDateDaysOfWeek.toString() : row.departureDateDaysOfWeek);
  }
  function duplicateDetection(row, gridData) {
    var rowToCompare;
    var counter = 0;
    for (var i = 0; i < gridData.length; ++i) {
      rowToCompare = gridData[i];
      if (areRowsTheSame(rowToCompare, row)) {
        ++counter;
      }
      if (counter > 1) {
        return 'Record already exists.';
      }
    }
  }
  function validateRow(row) {
    if (!row.hasOwnProperty('flightTagName') || row.flightTagName === '' || row.flightTagName.match(/^\s+$/)) {
      return '\'Flight Category Name\' can not be empty.';
    }
    if (row.flightTagName.length > 30) {
      return '\'Flight Category Name\' can be maximum 30 characters length.';
    }
    var regExp = /^[a-zA-Z0-9 _<>=\-]+$/;
    if (!row.flightTagName.match(regExp)) {
      return '\'Flight Category Name\' contains invalid characters. Only alphanumeric characters and -, _, <, >, = are allowed.';
    }
    if (!row.hasOwnProperty('carrierCode') || row.carrierCode === '') {
      return '\'Airline Code\' can not be empty.';
    }
    if ((!row.hasOwnProperty('flightNumber') || !row.flightNumber || row.flightNumber === '') && (!row.hasOwnProperty('legOrigin') || !row.legOrigin || row.legOrigin === '') && (!row.hasOwnProperty('legDestination') || !row.legDestination || row.legDestination === '')) {
      return 'One of these must be provided: \'Flight Number\', \'Leg Origin\', \'Leg Destination\'.';
    }
    if (!row.hasOwnProperty('departureDateRangeStart') || row.departureDateRangeStart === '' || !row.departureDateRangeStart) {
      return '\'Start Departure Date\' can not be empty.';
    }
    if (row.departureDateRangeStart.isAfter(row.departureDateRangeEnd)) {
      return '\'Start Departure Date\' must be earlier or equal \'End Departure Date\'.';
    }
    var isDepartureTimeRangeStartNotEmpty = row.hasOwnProperty('departureTimeRangeStart') && !_.isEmpty(row.departureTimeRangeStart);
    if (isDepartureTimeRangeStartNotEmpty && !TIME_FORMAT_REG_EXP.test(row.departureTimeRangeStart.toISOString())) {
      return '\'Start Departure Time\' must fit format HH:mm.';
    }
    var isDepartureTimeRangeEndNotEmpty = row.hasOwnProperty('departureTimeRangeEnd') && !_.isEmpty(row.departureTimeRangeEnd);
    if (isDepartureTimeRangeEndNotEmpty && !TIME_FORMAT_REG_EXP.test(row.departureTimeRangeEnd.toISOString())) {
      return '\'End Departure Time\' must fit format HH:mm.';
    }
    if (isDepartureTimeRangeStartNotEmpty && isDepartureTimeRangeEndNotEmpty && row.departureTimeRangeStart.isAfter(row.departureTimeRangeEnd)) {
      return '\'Start Departure Time\' must be earlier or equal \'End Departure Time\'.';
    }
    return '';
  }
  $scope.removeFlightTags = function () {
    return configurationFlightTagService.remove($scope.selectedRows)["catch"](postColumnsErrorHandler).then(reloadFlightTag);
  };
  $scope.$on('grid:clearAndLoadData:configuration-flight-tag', reloadFlightTag);
};
ConfigurationFlightTagController.$inject = ['DataRetrieverService', '$scope', 'ConfigurationFlightTagService', '$q', '$log', 'StaticDataService', 'ConfigurationService'];
module.exports = ConfigurationFlightTagController;